import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Checkbox, IconButton } from "@material-ui/core";
import { DataGrid, DialogState, EditableDialog, GridColumnProps, SelectMode } from "@roc/ui";
import { Edit } from "@material-ui/icons";
import { formatCurrency } from "@roc/ui/utils";
import { EditDqDataModalForm } from "./editDQDataModalForm";

const columns: GridColumnProps[] = [
  {
    field: 'tempId',
    headerName: '',
    maxWidth: 75,
    cellRenderer: 'selectedCellRenderer',
    sortable: false,
  },
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 120,
    sortable: false,
  },
  {
    field: 'servicerId',
    headerName: 'Servicer Id',
    maxWidth: 150,
    sortable: false,
  },
  {
    field: 'address',
    headerName: 'Address',
    minWidth: 300,
    sortable: false,
  },
  {
    field: 'dqAmount',
    headerName: 'Amount',
    cellRenderer: 'amountRenderer',
    maxWidth: 120,
    sortable: false,
  },

  {
    field: 'appliedDqAmount',
    headerName: 'Applied Amount',
    cellRenderer: 'amountRenderer',
    maxWidth: 150,
    sortable: false,
  },
  {
    field: 'comments',
    headerName: 'Comments',
    minWidth: 100,
    sortable: false,
  },
  {
    field: 'drawsDqDataId',
    headerName: '',
    cellRenderer: 'actionCellRenderer',
    maxWidth: 100,
    sortable: false,
  }
]

export const DrawDQDataGrid = observer(() => {
  const { sendWireInternalStore } = useRocInternalPortalStore();
  const gridStore = sendWireInternalStore.drawDQDataGridStore;

  const [modalOpen, setModalOpen] = useState(false);

  const CheckboxColumn = observer(({ store, node }) => {
    const id = node.data?.tempId;
    const isSelected = store.selectedDQItems.some(
      p => id === p.tempId
    );
    const isDisabled = node.data?.disabled;
    return (
      <Checkbox
        checked={isSelected}
        onChange={(e, checked) => {
          store.selectedDQRow(node.data);
        }}
        disabled={isDisabled || store.readOnlyMode}
        color="primary"
      />
    );
  })

  const EditColumn = observer(({ store, node }) => {
    const isDisabled = node.data?.disabled;
    return (
      <IconButton onClick={() => onEditData(node.data)} disabled={isDisabled || store.readOnlyMode}>
        <Edit color="primary" />
      </IconButton>
    );
  })

  const frameworkComponents = {
    actionCellRenderer: (params) => {
      return (
        <EditColumn store={sendWireInternalStore} node={params.node} />
      )
    },
    amountRenderer: ({ value }) => {
      return value ? formatCurrency(value) : '';
    },
  }

  const getDialogContent = () => {
    return <EditDqDataModalForm store={sendWireInternalStore} />
  };

  const onEditData = dqData => {
    setModalOpen(true);
    sendWireInternalStore.editDQDataStore.loadDqData(dqData);
  };

  const closeModal = () => {
    setModalOpen(false);
  }

  const handleEdit = () => {
    sendWireInternalStore.setLoanDqDataEdit();
    closeModal();
  }

  return (
    <>
      <DataGrid
        columns={columns}
        rows={gridStore.gridData.data.rows}
        domLayout="autoHeight"
        suppressRowClickSelection={true}
        frameworkComponents={{
          ...frameworkComponents,
          selectedCellRenderer: params => {
            return <CheckboxColumn store={sendWireInternalStore} node={params.node} />
          },
        }}
      />
      <EditableDialog
        title={'Delinquent Loan'}
        open={modalOpen}
        dialogState={DialogState.EDIT}
        handleClose={closeModal}
        dialogContent={getDialogContent()}
        handleEdit={() => handleEdit()}
      />
    </>
  )


})